var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 256,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 256",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "98.030868%",
    x2: "58.887706%",
    xlinkHref: "#a",
    y1: ".1606%",
    y2: "40.765525%"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "100.665247%",
    x2: "55.40181%",
    xlinkHref: "#a",
    y1: ".455032%",
    y2: "44.726981%"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m244.657778 0h-122.951111c0 14.7201046 5.847538 28.837312 16.256224 39.2459977 10.408686 10.4086858 24.525893 16.2562245 39.245998 16.2562245h22.648889v21.8666667c.019613 30.6252661 24.8414 55.4470541 55.466666 55.4666671v-122.1688893c0-5.89103736-4.775629-10.6666667-10.666666-10.6666667z",
    fill: "#2684ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m183.822222 61.2622222h-122.9511109c.0196127 30.6252666 24.8414001 55.4470538 55.4666669 55.4666668h22.648889v21.937778c.039238 30.625256 24.87694 55.431136 55.502222 55.431111v-122.1688891c0-5.8910373-4.775629-10.6666667-10.666667-10.6666667z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m122.951111 122.488889h-122.951111c0 30.653031 24.8491913 55.502222 55.5022222 55.502222h22.72v21.866667c.0195448 30.597542 24.7980628 55.407869 55.3955558 55.466666v-122.168888c0-5.891038-4.77563-10.666667-10.666667-10.666667z",
    fill: "url(#c)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/jira.9cfc2fbc452fc314399456ceb6bb6b8e.svg";
export { ForwardRef as ReactComponent };